import React, {Component, PropTypes} from 'react';
import {Link} from "react-router";
import {ellaUrl} from '../../../path.config'
import FormInput from 'CONFIG/component/form/formInput'
import {language} from 'UTIL/common'
export default class UserDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.params.id,
            userBase: {},
            roleList: [],
            userType: [],
            selectRole: [],
            extendsValue: [],
            url: ellaUrl
        };
    }
    componentDidMount() {
        var id = this.state.id;
        $.ajax({
            type: "GET",
            url: this.state.url + "/user/toUpdate/" + id,
            contentType: "application/json;charset=UTF-8",
            success: function (data) {
                console.log(data)
                if (data.data != null) {
                    var userBase = data.data.userBase;
                    var selectRole = data.data.selectRole;
                    var userType = data.data.userType;
                    this.setState({
                        map:data.data,
                        userBase: data.data.userBase,
                        roleList: data.data.roleList,
                        dvcTypes: userBase.dvcTypes,
                        selectRole: selectRole,
                        userType: userType,
                    });
                    $("#loginName").val(userBase.loginName);
                    $("#realName").val(userBase.realName);
                    $("#telephone").val(userBase.telephone);
                    $("#email").val(userBase.email);
                    $("#address").val(userBase.address);
                    $("#userTypeId").val(userBase.userTypeId);
                }
            }.bind(this),
            error: function (data) {
                console.log("Get nodeVos info error");
            }.bind(this),
        });
    }
    render() {
        const _this = this;
        var selectrole = this.state.selectRole;
        const roleList = this.state.roleList.map(function (str, index) {
            var div = <div className="col-xs-3"><input className="input-hidden" id="roleType" value={str.id}
                                                       type="checkbox"></input>
                <span className="checkbox-body"></span>
                <span className="checkbox-text">{str.roleName}</span></div>;
            if (selectrole != null && selectrole.indexOf(str.id) != -1)
                div = <div className="col-xs-3"><input className="input-hidden" id="roleType" value={str.id}
                                                       type="checkbox" checked></input>
                    <span className="checkbox-body"></span>
                    <span className="checkbox-text">{str.roleName}</span></div>;

            return div;
        });

        const userType = this.state.userType.map(function (str, index) {
            return <option value={str.id}>{str.name}</option>
        })
        return (
            <div >
                <section className="content-header ">
                    <h1> {language()['userManage']}
                        <small>{language()['managersDetail']}</small>
                    </h1>
                </section>
                <section className="content">
                    <div className="box box-primary color-palette-box">
                        <div className="box-header with-border">
                            <i className="fa fa-plus-circle"></i>
                            <h3 className="box-title">{language()['managersDetail']}</h3>
                        </div>
                        <div className="box-body">
                            <form id="micaFrom" className="form-horizontal">
                                <FormInput name="loginName" id="loginName"/>
                                <FormInput name="realName" id="realName"/>
                                <FormInput name="telephone" id="telephone"/>
                                <FormInput name="email" id="email"/>
                                <FormInput name="address" id="address"/>
                                <div className="row form-group">
                                    <label  className="multi-label control-label col-xs-2">{language()['userType']}</label>
                                    <div className="col-xs-3">
                                        <select  className="form-control" id="userTypeId">
                                            <option value={2}>{language()['managers']}</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <label className="multi-label control-label col-xs-2">{language()['selectRole']}</label>
                                    <div className="col-xs-10" style={{marginBottom: "15px"}}>
                                        {roleList}
                                    </div>
                                </div>

                            </form>
                        </div>
                        <div className="box-footer">
                            <div className="col-xs-2"></div>
                            <div className="col-xs-1 text-center">
                                <Link to="/ella/user/user/administratorsList" className="btn btn-default btn-md">
                                    返回
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./modules/ella/user/user/administratorsDetail.js